// frontend/src/pages/admin/lcl/components/PeriodFilter.jsx
// Filtre période avec sélection précise : mois, semaine, année, tout.
// period = { mode: 'all'|'month'|'week'|'year', value?: string }
//   mode='month'  → value = 'YYYY-MM'     (input type=month)
//   mode='week'   → value = 'YYYY-Www'    (input type=week, ISO 8601)
//   mode='year'   → value = 'YYYY'
//   mode='all'    → pas de value

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 6 }, (_, i) => CURRENT_YEAR + 1 - i); // 5 past + current + 1 next

export default function PeriodFilter({ period, setPeriod }) {
  const mode = period?.mode || 'all';

  const setMode = (newMode) => {
    if (newMode === 'all') return setPeriod({ mode: 'all' });
    if (newMode === 'month') {
      const m = new Date().toISOString().slice(0, 7); // YYYY-MM
      return setPeriod({ mode: 'month', value: m });
    }
    if (newMode === 'week') {
      const d = new Date();
      // ISO week: YYYY-Www
      const y = d.getFullYear();
      const jan1 = new Date(y, 0, 1);
      const dayOfYear = Math.floor((d - jan1) / 86400000) + 1;
      const week = String(Math.ceil((dayOfYear + jan1.getDay()) / 7)).padStart(2, '0');
      return setPeriod({ mode: 'week', value: `${y}-W${week}` });
    }
    if (newMode === 'year') return setPeriod({ mode: 'year', value: String(CURRENT_YEAR) });
  };

  return (
    <div className="inline-flex items-center gap-1">
      <div className="inline-flex rounded border border-gray-200 overflow-hidden">
        {[
          { k: 'month', l: 'Mois'  },
          { k: 'week',  l: 'Semaine' },
          { k: 'year',  l: 'Année' },
          { k: 'all',   l: 'Tout'  },
        ].map(({ k, l }) => (
          <button
            key={k}
            onClick={() => setMode(k)}
            className={`px-2.5 py-1 text-[11px] font-medium transition-colors ${
              mode === k ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            {l}
          </button>
        ))}
      </div>

      {mode === 'month' && (
        <input
          type="month"
          value={period.value || ''}
          onChange={(e) => setPeriod({ mode: 'month', value: e.target.value })}
          className="px-2 py-1 text-[11px] border border-gray-200 rounded
                     focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        />
      )}
      {mode === 'week' && (
        <input
          type="week"
          value={period.value || ''}
          onChange={(e) => setPeriod({ mode: 'week', value: e.target.value })}
          className="px-2 py-1 text-[11px] border border-gray-200 rounded
                     focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        />
      )}
      {mode === 'year' && (
        <select
          value={period.value || String(CURRENT_YEAR)}
          onChange={(e) => setPeriod({ mode: 'year', value: e.target.value })}
          className="px-2 py-1 text-[11px] border border-gray-200 rounded bg-white
                     focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
          {YEAR_OPTIONS.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      )}
    </div>
  );
}

// Helper : test si une date est dans la période sélectionnée
export function inPeriod(dateStr, period) {
  if (!dateStr) return false;
  const mode = period?.mode || 'all';
  if (mode === 'all') return true;
  const d = new Date(dateStr);
  if (isNaN(d)) return false;

  if (mode === 'year') {
    return String(d.getFullYear()) === String(period.value);
  }
  if (mode === 'month') {
    // period.value = 'YYYY-MM'
    const ym = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    return ym === period.value;
  }
  if (mode === 'week') {
    // period.value = 'YYYY-Www'
    const y = d.getFullYear();
    const jan1 = new Date(y, 0, 1);
    const dayOfYear = Math.floor((d - jan1) / 86400000) + 1;
    const week = String(Math.ceil((dayOfYear + jan1.getDay()) / 7)).padStart(2, '0');
    return `${y}-W${week}` === period.value;
  }
  return true;
}
